const equivalencesRomanInt = {I: 1, V: 5, X: 10, L: 50, C: 100, D: 500, M: 1000};
const equivalencesIntRoman2 = {n1: 'I', n5: 'V', n10: 'X', n50: 'L', n100: 'C', n500: 'D', n1000: 'M'};
export default [
	{numeral: 1, roman: 'I'}, {numeral: 5, roman: 'V'}, {numeral: 10, roman: 'X'},
	{numeral: 50, roman: 'L'}, {numeral: 100, roman: 'C'}, {numeral: 500, roman: 'D'},
	{numeral: 1000, roman: 'M'}
];
export { equivalencesRomanInt, equivalencesIntRoman2 }